import get from "lodash/get"
import getGoogleAddressComponent from "./getGoogleAddressComponent"

/**
 * Formats the Google address data into a structured address object.
 * @param {Object} data - The Google address data.
 * @returns {Object} - The formatted address object.
 */
export default (data, LDFFReleasePreventEligibilityApiFailureForCityAndZip) => {
  const streetNumberFromUser = /^\d+\s/.test(get(data, `label`))
    ? data.label.replace(/ .*/, "")
    : ""
  const address = {
    formattedAddress: data.gmaps.formatted_address,
    label: data.label,
    streetNumber:
      getGoogleAddressComponent(data, `street_number`) || streetNumberFromUser,
    streetName: getGoogleAddressComponent(data, `route`),
    county: getGoogleAddressComponent(data, `administrative_area_level_2`),
    lat: data.location.lat,
    lng: data.location.lng,
    city: LDFFReleasePreventEligibilityApiFailureForCityAndZip
      ? getGoogleAddressComponent(data, `locality`) ||
        getGoogleAddressComponent(data, `administrative_area_level_3`) ||
        getGoogleAddressComponent(data, `neighborhood`)
      : getGoogleAddressComponent(data, `locality`) ||
        getGoogleAddressComponent(data, `administrative_area_level_3`),
    state: getGoogleAddressComponent(data, `administrative_area_level_1`),
    country: getGoogleAddressComponent(data, `country`),
    postalCode: getGoogleAddressComponent(data, `postal_code`),
    gPlaceId: data.gmaps?.place_id || data.placeId,
    streetValue: getGoogleAddressComponent(data, `subpremise`) || "",
  }
  return address
}
